const dogPurchase = {
    state: {
		dogPurchasePendingRequestCount: 0
	},
	mutations: {
        setdogPurchasePendingRequestCount(state, dogPurchasePendingRequestCount) {
            state.dogPurchasePendingRequestCount = dogPurchasePendingRequestCount;
        },
	},
	getters: {
		getdogPurchasePendingRequestCount(state) {
            return state.dogPurchasePendingRequestCount;
        },
	}
}

export default dogPurchase